// extracted by mini-css-extract-plugin
module.exports = {"component":"SortableHeader_component__GoJrS","arrow":"SortableHeader_arrow__kSjm0"};